import { LoaderProviderProps } from "../../app/components/LoaderProviderA";

export function isLoadingClassName<T>(
  loader: LoaderProviderProps<T>["loader"],
  depth: "a" | "b"
) {
  return loader.tag === "loading" || loader.tag === "initial"
    ? `mkhc-is-loading-${depth}`
    : undefined;
}
